import React from "react";
import { Card, CardText } from "react-md";
import {map, isEmpty, size} from "lodash";

import Carousel from "../../Carousel";
import AtollonLogo from "../../../assets/img/atollon-logo-black.png";
import {TouchTableHeader} from "../../../AtollonTheme/ReactElements";
import {TouchOrganizations} from "../../../Atollon/Organizations";

const Organizations = ({ history, data }) => {
  return data && !isEmpty(data.item) ? (
    <div className="">

        <TouchTableHeader
            title={"Organizace, ve kterých jsem členem"}
            titleNumber={data && !isEmpty( data.item ) ? size( data.item ) : null}
        />

        <TouchOrganizations
            gotoAdminPage={true}
            organizationArray={data.item}
            history={history}
        />
    </div>
  ) : (
    <div />
  );
};

export default Organizations;



// WEBPACK FOOTER //
// ./src/components/settings/organizations/OrgMember.js